import { examsApi } from "api/examsApi";
import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";

export const useExams = (skip: number, limit: number, filter: string = "", orderBy: string = "") => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.EXAMS(skip, limit, filter, orderBy),
    queryFn: () => examsApi.fetch(skip, limit, filter, orderBy),
    placeholderData: keepPreviousData,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.EXAMS(skip, limit, filter, orderBy),
    });
  };

  return { invalidate, isLoading, isFetching, exams: data?.data.data ?? [], total: data?.data.total ?? 0 };
};
